import { useEffect, useState } from "react";
import Modal from "../../ReusableComponents/Modal";
import DateTimePicker from "../../ReusableComponents/DateTimePicker";
import { Button } from "../../Components/Helper";
import { GLOBAL_STYLES } from "../../appConstants";
import { useSelector } from "react-redux";
import Popup from "../../ReusableFunctions/Popup";
import MultiSelectField from "../../ReusableComponents/MultiSelectField";
import SelectField from "../../ReusableComponents/SelectField";
import Form from "../../ReusableComponents/Form";
import { getDistricts, getStates, getTalukas } from "../../apis/locations";

const TeleSalesFilter = ({ filter, onFilterChange, open, onClose }) => {

    const userDetails = useSelector(state => state.user?.user)

    const [Filter, setFilter] = useState(null);
    const [State, setState] = useState([])
    const [Taluka, setTaluka] = useState([])
    const [District, setDistrict] = useState([])

    const [StatesLoading, setStatesLoading] = useState(false);
    const [TalukaLoading, setTalukaLoading] = useState(false);
    const [districtLoading, setdistrictLoading] = useState(false)

    const [refresh,setRefresh] = useState(0)
    

    const handleFilterChange = (updatedFilter) => {
        setFilter(updatedFilter);
    };

    useEffect(() => {
        console.log("filter",filter);
        let data = { ...filter,
            state: filter.state ? { label: filter.state, value: filter.state } : undefined,
            district: filter.district ? filter.district.map(x => ({ label: x, value: x })) : [],
            taluka: filter.taluka ? filter.taluka.map(x => ({ label: x, value: x })) : []
        }
        // console.log(data)
        setFilter(data)

        getStatesFunc()

        if (data.district.length > 0) {
            getDistrictFunc(undefined,filter.state)
        }

        if (data.taluka.length > 0) {
            getTalukasFunc(undefined,filter.district)
        }
        
    }, [])



    const getStatesFunc = async () => {
        setStatesLoading(true);
        try {
          const states = await getStates()
          setState(states?.records)
        } catch (err) {
          console.log(err);
          Popup.alert("Error", err.errorMessage, "ERROR");
        }finally{
          setStatesLoading(false);
        }
      }

    const getDistrictFunc = async (stateCode, stateName) => {
        try {
        setdistrictLoading(true);
          const districts = await getDistricts(stateCode, stateName)
          setDistrict(districts?.records)
          setdistrictLoading(false);
        } catch (err) {
            setdistrictLoading(false);
          console.log(err);
          Popup.alert("Error", err.errorMessage, "ERROR");
        }
      }




    const getTalukasFunc = async (districtName) => {
        try {
            setTalukaLoading(true);
            if (districtName?.find((x) => x === "All")) {
                setTaluka((prev)=>[...prev])
                return ;
            }
            if(districtName?.length>0){
            for (let dist of districtName) {
                const {records:talukas} = await getTalukas(undefined,dist);
                setTaluka((prev) => [...prev, ...talukas]);
            }
           }
            setTalukaLoading(false);
        } catch (err) {
            setTalukaLoading(false);
            console.log(err);
            Popup.alert("Error", err.errorMessage, "ERROR");
        }
    };

    console.log("talukas",Filter?.taluka);


    return (
        <Modal
            header={"Filter"}
            contentStyle={{ width: "730px", height: userDetails.bhumeet_role != 'Admin' ? "auto" : "364px" }}
            headingStyle={{ fontSize: "18px", fontWeight: 600 }}
            headerContainerStyle={{ padding: "20px" }}
            open={open}
            onClose={onClose}
        >
            <div style={{ padding: "20px 30px", display: "flex", flexDirection: "column", width: "100%", gap: "20px" }}>
                {/* Date Filter Section */}
                <div style={{ display: "block", justifyContent: "space-between", alignItems: "center", width: "100%", gap: "10%" }}>
                    {Filter &&
                    
                    <Form style={{ width: "100%" }}
                        onSubmitForm={async (form) => {

                            // console.log(Filter)
                            let finalData = Filter
                            
                            if (finalData?.district?.find(x => x.value === "All")) {
                                finalData.district = undefined
                            }
                            if (finalData?.taluka?.find(x => x.value === "All")) {
                                finalData.taluka = undefined
                            }
                            finalData.district = Filter?.district?.map(x => x.value)
                            finalData.taluka = Filter?.taluka?.map(x => x.value)

                            finalData.state = Filter.state?.value == 'All' ? undefined : Filter.state?.value
                            finalData['currentPage'] = 1
                            // console.log(finalData)
                           
                            onFilterChange(finalData)
                            onClose()
                        }}
                        initialValues={Filter}
                    >

                        {(onsubmit) => (

                            <>
                                <div >
                                    <div style={{ display: "flex", justifyContent: "space-between", gap: "10px" }}>
                                        <DateTimePicker
                                            title="From"
                                            hideNxt={new Date()}
                                            selectedDateTime={Filter.fromDate}
                                            minTime={new Date().setHours(0, 0, 0, 0)}
                                            maxTime={new Date().setHours(23, 59)}
                                            onChange={(date) => {
                                                handleFilterChange({
                                                    ...Filter,
                                                    fromDate: new Date(date).toISOString()
                                                });
                                            }}
                                        />
                                        <DateTimePicker
                                            title="To"
                                            hidePrev={Filter.fromDate}
                                            selectedDateTime={Filter.toDate}
                                            minTime={new Date(Filter?.fromDate).toDateString() === new Date(Filter?.toDate).toDateString()
                                                ? new Date(new Date(Filter.fromDate).setMinutes(new Date(Filter.fromDate).getMinutes() + 1))
                                                : new Date().setHours(0, 0, 0, 0)}
                                            maxTime={new Date().setHours(23, 59)}
                                            onChange={(date) => {
                                                if (new Date(Filter.fromDate) < new Date(date)) {
                                                    // console.log(date)
                                                    if (!Filter.toDate) {
                                                        let dates = new Date(date).setHours(23, 59)
                                                        handleFilterChange({
                                                            ...Filter,
                                                            toDate: new Date(dates).toISOString()
                                                        });
                                                    } else {
                                                        handleFilterChange({
                                                            ...Filter,
                                                            toDate: new Date(date).toISOString()
                                                        });
                                                    }

                                                } else {

                                                    handleFilterChange({
                                                        ...Filter,
                                                        toDate: Filter.toDate ? new Date(Filter.toDate) : new Date()
                                                    })
                                                }
                                            }}
                                            isDisable={!(Filter.fromDate)}
                                        />

                                    </div>
                                    <div style={{ display: "flex", justifyContent: "space-between", gap: "10px",marginTop:"10px" }}>
                                        <SelectField
                                            name={"state"}
                                            label={"State"}
                                            // defaultCall
                                            isLoading={StatesLoading}
                                            isDisabled={StatesLoading}
                                            list={[{ label: "All", value: "All" },...(State?.map((state) => ({
                                                label: state?.state_name_english,
                                                value: state?.state_name_english,
                                            })))]}
                                            // validation={selectFieldValidation}
                                            styles={{
                                                width: "215px",
                                                height: "18px",
                                                fontSize: "13px",
                                                margin: "0 0 0 -1px",
                                            }}
                                            // validation={selectFieldValidation}
                                            placeholderText={"Select State"}
                                            defaultValue={Filter?.state || { label: "Select State", value: undefined }}
                                            menuPortalTarget={document.getElementById('modalHolder')}
                                            handleChange={(state) => {
                                                setDistrict([])
                                                setTaluka([]);
                                                if (state?.label !== "All") {
                                                    getDistrictFunc(undefined,state?.label);

                                                }
                                            setFilter((prev) => ({
                                                ...prev,
                                                state: state,
                                                taluka: [],
                                                district: [],
                                            }));
                                            
                                            }}
                                            containerStyle={{
                                                width: "100%",
                                                maxWidth: "30%",
                                                minHeight: "80px",
                                            }}
                                            isSearchable={true}
                                        />
                                        <MultiSelectField
                                            name="district"
                                            label="District"
                                            className={'district'}
                                            isLoading={districtLoading}
                                            list={District?.length > 0 ? [
                                                { label: "All", value: "All" },
                                                ...(District ? District.map((district) => ({
                                                    label: district.district_name_english,
                                                    value: district.district_name_english,
                                                })) : [])
                                            ] : []}

                                            styles={{ width: "200px" }}
                                            controlStyle={{ width: "215px", height: "100%" }}
                                            
                                            placeholderText="Select District"
                                            value={Filter?.district}
                                            defaultValue={Filter?.district}
                                            // validation={selectFieldValidation}
                                            handleChange={(selectedOptions) => {
                                                const wasAllSelected = Filter?.district?.some(opt => opt.value === "All");
                                                const isAllSelected = selectedOptions.some(opt => opt.value === "All");
                                        
                                                // Case 1: If "All" was previously selected alone and now selecting other options
                                                if (wasAllSelected && Filter?.district?.length === 1 && selectedOptions.length > 1) {
                                                    // Remove "All" and keep only the new selections
                                                    selectedOptions = selectedOptions.filter(opt => opt.value !== "All");
                                                }
                                                // Case 2: If selecting "All" along with other options
                                                else if (isAllSelected && selectedOptions.length > 1) {
                                                    // Just keep "All" and remove others
                                                    selectedOptions = [{ label: "All", value: "All" }];
                                                }
                                        
                                                // Update state based on final selection
                                                if (selectedOptions.some(opt => opt.value === "All")) {
                                                    setTaluka([]);
                                                    setFilter(prev => ({
                                                        ...prev,
                                                        taluka: [],
                                                        district: [{ label: "All", value: "All" }]
                                                    }));
                                                } else if (selectedOptions) {
                                                    setTaluka([]);
                                                    getTalukasFunc(selectedOptions.map(x => x.value));
                                                    setFilter(prev => ({
                                                        ...prev,
                                                        taluka: [],
                                                        district: selectedOptions
                                                    }));
                                                }
                                            }}
                                            isMulti
                                            isSearchable={true}
                                        />

                                        <MultiSelectField
                                            isSearchable={true}
                                            name="taluka"
                                            label="Taluka"
                                            value={Filter?.taluka}
                                            defaultValue={Filter?.taluka}
                                            list={Filter?.district.length > 0 ? [
                                                { label: "All", value: "All" },
                                                ...(Taluka ? Taluka.map((taluka) => ({
                                                    label: taluka.subdistrict_name_english,
                                                    value: taluka.subdistrict_name_english,
                                                })) : [])
                                            ] : []}

                                            styles={{ width: "200px" }}
                                            controlStyle={{ width: "215px", height: "100%" }}
                                            placeholderText="Select Taluka"
                                            // validation={selectFieldValidation}
                                            handleChange={(state) => {
                                                 if (state) {
                                                    setFilter((prev) => ({
                                                        ...prev,
                                                        taluka: state,
                                                    }));
                                                }
                                            }}
                                            isMulti
                                        />
                                    </div>


                                </div>

                                <div
                                    style={{
                                        gridColumn: "span 3", // Spanning full width
                                        display: "flex",
                                        justifyContent: "space-between",
                                        gap: "10px",
                                        padding: "20px",
                                        height: "70px",
                                    }}
                                >

                                    <div
                                        onClick={async () => {
                                            setFilter({
                                                state: "",
                                                district: [],
                                                taluka: [],
                                                Status:"open",
                                                currentPage: 1
                                            })
                                            setDistrict([])
                                            setTaluka([])
                                        }} style={{ width: "74px", color: GLOBAL_STYLES.BG_ACTIVE, fontWeight: 600, fontSize: "15px", cursor: 'pointer', display: "flex", alignItems: "center", marginTop: "7px" }}>
                                        Clear all
                                    </div>


                                    <div style={{display:"flex",gap:"5px"}}>
                                    <Button
                                        isDisabled={false}
                                        text={"Submit"}
                                        onClick={onsubmit}
                                        className="btn-large"
                                    />
                                    <Button
                                        text="Cancel"
                                        onClick={onClose}
                                        className="btn-large lg-cancel-btn"
                                        isBtnNotActive={true}
                                    />
                                    </div>
                                </div>
                            </>
                        )}

                    </Form>
                    
                    }
                    





                </div>








            </div>
            {/* <div style={{ display: "flex", justifyContent: "space-between", padding: "20px 30px", borderTop: '0.5px solid #BFC8D9' }}>
                <div
                    onClick={async () => {
                        setFilter({
                            fromDate: null,
                            toDate: null,
                            Status: 'open',
                            Substatus:[],
                            currentPage:1
                        })
                    }} style={{ width: "100px", color: GLOBAL_STYLES.BG_ACTIVE, fontWeight: 600, fontSize: "14px", cursor: 'pointer', display: "flex", alignItems: "center", justifyContent: "start" }}>
                    Clear all
                </div>
                <Button
                    text={"Apply"}
                    style={{ width: "130px", height: "38px", fontSize: "15px", marginRight: "10px" }}
                    onClick={() => {
                        onFilterChange(Filter)
                    }}
                />
            </div> */}
        </Modal>
    );
};

export default TeleSalesFilter;